import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';

@withText(props => ({
    orderNumber: <Text id='input.orderNumber-help'>orderNumber</Text>,
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
    installation: <Text id='input.installation-help'>installation</Text>,
    url: <Text id='input.url-help'>url</Text>,
}))
@observer
class ViewGpsPosition extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('raceClass'),
            sectionsRace: fields.get('race'),
        };
    }

    createFile = async () => {
        const { callback = () => {} } = this.props;
        const { fileStore } = this.props.stores;
        const { newFile } = fileStore;
        const response = await fileStore.adminCreate(newFile);
        if (response.status === 201) {
            callback();
        }
    }

    componentDidMount() {
        // Pre-set the clicked position as default for new checkpoints/waypoints
        const { pos } = this.props;
        const { raceClassStore, raceStore } = this.props.stores;
        if (pos && pos.lat && pos.lng) {
            // Set default position for new checkpoints/waypoints
            raceClassStore.updateKeyValue('newObject', { lat: pos.lat, lng: pos.lng });
            raceStore.updateKeyValue('newObject', { lat: pos.lat, lng: pos.lng });
        }
    }

    render() {
        const { infoList, resultList, adminList, sections, sectionsRace } = this.state;
        const { pos, drawerLevel } = this.props;
        const { userStore, raceStore, raceClassStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(newCustomer, null, 4)}</xmp> */}
                    <div class={`${darkmode ? 'bg-darkmode' : 'bg-lightmode'} d-flex flex-column justify-content-start h-100 pt-3`}>
                        {pos && <>
                            <div class='px-3 py-2 mb-3 mx-3 rounded border'>
                                <div class='d-flex flex-row align-items-center mb-2'>
                                    <i class='fa-solid fa-map-marker-alt text-primary me-2' />
                                    <span class='font-weight-bold'>Clicked Position</span>
                                </div>
                                <div class='d-flex flex-row'>
                                    <div class='me-4'>
                                        <small class='text-muted'>Lat:</small> <span class='font-weight-bold'>{pos.lat?.toFixed(6)}</span>
                                    </div>
                                    <div>
                                        <small class='text-muted'>Lng:</small> <span class='font-weight-bold'>{pos.lng?.toFixed(6)}</span>
                                    </div>
                                </div>
                                <small class='text-muted'>This position will be used when adding new checkpoints or waypoints</small>
                            </div>
                        </>}
                        <h5 class='px-3'>RaceClass</h5>
                        <div class={`${darkmode ? 'bg-darkmode' : 'bg-lightmode'} d-flex flex-column justify-content-start h-100`}>
                            <FormFieldsCompact
                                stores={this.props.stores}
                                sections={sections}
                                fields={[
                                    'checkpoints', 'waypoints', 'sponsors'
                                ]}
                                holdingStore={raceClassStore}
                                objectName={'raceClass'}
                                isNew={false}
                                drawerLevel={drawerLevel}
                                isAdmin={false}
                            />
                        </div>

                        <h5 class='mt-5 px-3'>Race</h5>
                        <div class={`${darkmode ? 'bg-darkmode' : 'bg-lightmode'} d-flex flex-column justify-content-start h-100`}>
                            <FormFieldsCompact
                                stores={this.props.stores}
                                sections={sectionsRace}
                                fields={[
                                    'waypoints', 'sponsors'
                                ]}
                                holdingStore={raceStore}
                                objectName={'race'}
                                isNew={false}
                                drawerLevel={drawerLevel}
                                isAdmin={false}
                            />
                        </div>



                    </div>
                </div>
            </div>
        </>);
    }
}

export default ViewGpsPosition;
